module.exports = __webpack_public_path__ + "static/media/upskilling.26a7d5ff.png";